import request from '/src/api/request.js'


/**
 * 查询花名册
 */
export function selectUser(param) {
    return request({
        url: 'sys/user/selectUserRoster',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: param,
    })
}
/**
 * 查询花名册-详情
 */
export function selectRosterDetails(workId) {
    return request({
        url: 'sys/user/selectRosterDetails',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: workId
    })
}


/**
 * 更新花名册-合同
 */
export function updateContract(param) {
    return request({
        url: 'sys/user/updateCoachContract',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: param,
    })
}
/**
 * 删除花名册-合同
 */
export function deleteContract(workId) {
    return request({
        url: 'sys/user/deleteCoachContract',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: workId
    })
}


// 查询教练
export function selectCoach(param) {
    return request({
        url: 'oa/org/selectCoach',
        method: 'get',
        params: param
    })
}

/**
 * 修改密码
 */
export function updatePassWord(item) {
    return request({
        url: 'sys/auth/updatePassWord',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item,
    })
}